import { render } from "./LegacyConfigParametersIndex.vue?vue&type=template&id=44f1c3a6"
import script from "./LegacyConfigParametersIndex.vue?vue&type=script&lang=js"
export * from "./LegacyConfigParametersIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__